<script lang="ts">
    import { _ } from "svelte-i18n"
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/svelte-splide"
    import { sliderImageCursor } from "../../store"

    import Image from "./Image.svelte"

    export let content: Content

    let scrollY: number = 0
    let isOver: boolean = false
    let posX: number = 0
    let posY: number = 0

    const onMouseMove = (e) => {
        if (isOver) {
            posX = e.clientX
            posY = e.clientY
            $sliderImageCursor.element.style.top = posY + scrollY - 40 + "px"
            $sliderImageCursor.element.style.left = posX - 64 + "px"
        }
    }

    const onMouseLeave = (e) => {
        isOver = false
        $sliderImageCursor.element.style.top = "-999px"
        $sliderImageCursor.element.style.left = "-999px"
        $sliderImageCursor.element.classList.remove("show")
    }

    const onMouseEnter = (e) => {
        if (!isOver) {
            $sliderImageCursor.theme = "dark"
            $sliderImageCursor.element.classList.add("show")
        }
        if (content?.project?.mediaPlans?.items.length > 1) {
            isOver = true
        }
    }

    const onScroll = (e) => {
        if (isOver) {
            $sliderImageCursor.element.style.top = posY + scrollY - 40 + "px"
            $sliderImageCursor.element.style.left = posX - 64 + "px"
        }
    }
</script>

<svelte:window bind:scrollY on:scroll="{onScroll}" />

{#if content?.project?.mediaPlans?.items.length}
    <section
        class="project-plans-slider-section"
        on:mouseenter="{onMouseEnter}"
        on:mouseleave="{onMouseLeave}"
        on:mousemove="{onMouseMove}"
    >
        <Splide
            class="project-plans-slider {content?.project?.mediaPlans?.items.length <= 1 ? 'no-image-cursor' : ''}"
            aria-label="Current Projects Planns - Slider"
            options="{{
                pagination: false,
                arrows: content?.project?.mediaPlans?.items.length > 1,
            }}"
            hasTrack="{false}"
        >
            <div class="custom-wrapper">
                <SplideTrack>
                    {#each content?.project?.mediaPlans?.items as plan}
                        <SplideSlide>
                            <Image entryId="{content.id}" file="{plan.file}" />
                        </SplideSlide>
                    {/each}
                </SplideTrack>

                <div class="splide__actions">
                    <div class="splide__arrows">
                        <button class="splide__arrow splide__arrow--prev">
                            <img src="img/icons/bytesize_chevron-left.svg" alt="{$_('back')}" />
                        </button>
                        <button class="splide__arrow splide__arrow--next">
                            <img src="img/icons/bytesize_chevron-right.svg" alt="{$_('forward')}" />
                        </button>
                    </div>
                </div>
            </div>
        </Splide>
    </section>
{/if}
